import React from 'react';
import './SiteFooter.css';
export default function SiteFooter() {
  return (
    <footer className='site-footer'>
      <div className='footer-inner'>
        <div className='footer-head'>
          <h2 className='brand-title'>The InnerScience Personality Report</h2>
          <div className='brand-underline' aria-hidden />
          <p className='brand-tag'>Real personality insights. Real change. Real growth.</p>
        </div>
        <div className='footer-grid'>
          <nav className='footer-col links' aria-label='Footer links'>
            <h3 className='footer-heading'>Explore</h3>
            <ul className='footer-links'>
              <li>
                <a href='https://innersciencepersonalityreport.com/' target='_blank' rel='noreferrer'>Home</a>
              </li>
              <li>
                <a href='https://innersciencepersonalityreport.com/privacy-policy/'>Privacy Policy</a>
              </li>
            </ul>
          </nav>
          <div className='footer-col social'>
            <h3 className='footer-heading'>Social Media</h3>
            <div className='social-icons'>
              <a href='https://www.facebook.com/InnerSciencePersonalityReport/' className='social-link' aria-label='Facebook' target='_blank' rel='noreferrer'>
                <img src='/facebook_icon.png' alt='Facebook' />
              </a>
              <a href='https://www.instagram.com/innersciencepersonalityreport/' className='social-link' aria-label='Instagram' target='_blank' rel='noreferrer'>
                <img src='/ins_icon.jpeg' alt='Instagram' />
              </a>
              <a href='https://www.youtube.com/channel/UC07zTX4AJkP_7jvtcBjcIDw' className='social-link' aria-label='YouTube' target='_blank' rel='noreferrer'>
                <img src='/youtube_icon.png' alt='YouTube' />
              </a>
              <a href='https://www.tiktok.com/@innersciencepersonality' className='social-link' aria-label='TikTok' target='_blank' rel='noreferrer'>
                <img src='/tiktok_icon.png' alt='TikTok' />
              </a>
              <a href='https://www.linkedin.com/company/innerscience-personality-report/' className='social-link' aria-label='LinkedIn' target='_blank' rel='noreferrer'>
                <img src='/linkedin_icon.png' alt='LinkedIn' />
              </a>
            </div>
          </div>
          <div className='footer-col contact'>
            <h3 className='footer-heading'>Contact</h3>
            <p className='contact-line'>
              Email:{' '}
              <a href='mailto:contact@innersciencepersonalityreport.com'>
                contact@innersciencepersonalityreport.com
              </a>
            </p>
          </div>
        </div>
        <div className='footer-meta'>
          <p className='copyright'>
            © 2025 InnerScience Personality • All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}